import Flickity from 'flickity';
import Pubsub from 'pubsub-js';
import Events from './Events';
import MediaManager from './MediaManager';

const options = {
  nav: false,
  dots: true,
  initialindex: 0,
  infinescroll: false,
  externalcontrol: false,
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
  autoPlay: true,
};

class Carousel {
  constructor(elm) {
    this.elm = elm;
    this.isMobileOnly = this.elm.getAttribute('data-is-mobile-only') || true;

    if (this.isMobileOnly === 'false') {
      this.setupFlickity();
    } else {
      this.changeMedia();
      this.setupListeners();
    }
  }

  setupFlickity() {
    this.flkty = new Flickity(this.elm, options);
  }

  setupListeners() {
    Pubsub.subscribe(Events.CHANGE_MEDIA, this.changeMedia.bind(this));
  }

  changeMedia() {
    const media = MediaManager.getMedia();
    const isMobile = (media === MediaManager.medias.MOBILE);

    if (isMobile) {
      this.setupFlickity();
    } else if (this.flkty) {
      this.flkty.destroy();
    }
  }
}

export default {
  create(selector) {
    const instances = [];
    const elms = document.querySelectorAll(selector);

    for (let i = 0; i < elms.length; i += 1) {
      instances.push(new Carousel(elms[i]));
    }

    return instances;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Carousel.js